import React from 'react'
import BlogHero from './BlogHero'
import BlogSection from './BlogSection'

const Blog = () => {
  return (
    <div>
        <BlogHero/>
        <BlogSection/>
    </div>
  )
}

export default Blog